import { render, staticRenderFns } from "./commandsApiSelector.vue?vue&type=template&id=15633e80&"
import script from "./commandsApiSelector.vue?vue&type=script&lang=js&"
export * from "./commandsApiSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports